import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-2 mb-12 flex flex-inline flex-wrap gap-4 max-w-full"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Example = _resolveComponent("Example")!

  return (_ctx.exampleNames.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exampleNames, (exampleName, i) => {
          return (_openBlock(), _createBlock(_component_Example, {
            exampleData: _ctx.exampleDatas[i],
            key: exampleName,
            exampleName: exampleName
          }, null, 8 /* PROPS */, ["exampleData", "exampleName"]))
        }), 128 /* KEYED_FRAGMENT */))
      ]))
    : _createCommentVNode("v-if", true)
}